// Web side of the Metro platform split (the app.lissen.com build): the shared
// lib's browser entry, adapted to the same async signatures as the native
// entry so utils/rudderstack/index.ts is platform-agnostic.

import {
  getAnonymousId as browserGetAnonymousId,
  getSessionAttribution,
  identify as browserIdentify,
  initBrowserAnalytics,
  resetIdentity,
  screen,
  setAnonymousId as browserSetAnonymousId,
  setSessionAttribution,
  track,
} from "@libs/rudderstack/browser";
import type {
  BrowserAnalyticsConfig,
  EventName,
  TrackProperties,
} from "@libs/rudderstack/browser";

export { getSessionAttribution, screen, setSessionAttribution, track };

export type MobileAnalyticsConfig = Omit<
  BrowserAnalyticsConfig,
  "surface" | "loadOptions"
> & {
  /** Native-only (the RN SDK `env` option); ignored on web. */
  projectId?: string;
};

export const initAnalytics = (config: MobileAnalyticsConfig) =>
  initBrowserAnalytics({
    writeKey: config.writeKey,
    dataPlaneUrl: config.dataPlaneUrl,
    surface: "mobile-web",
    getUserId: config.getUserId,
    onError: config.onError,
    loadOptions: {
      autoTrack: {
        enabled: true,
      },
    },
  });

export const identify = async (
  userId: string,
  traits?: Record<string, unknown>,
): Promise<void> => {
  browserIdentify(userId, traits);
};

/** The browser SDK enqueues synchronously, so awaiting is trivially safe. */
export const trackAndWait = async <TEvent extends EventName>(
  name: TEvent,
  properties: TrackProperties<TEvent>,
): Promise<void> => {
  track(name, properties);
};

export const reset = async (): Promise<void> => {
  resetIdentity();
};

export const getAnonymousId = async (): Promise<string | null> =>
  browserGetAnonymousId();

export const setAnonymousId = async (id: string): Promise<void> => {
  browserSetAnonymousId(id);
};
